module.exports = __webpack_public_path__ + "391f82751029bedff54169e01fbf3f7d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/business-suit-s.png
// module id = 1245
// module chunks = 0